export const BOOKING_APPROVE_VALUE = 'BOOKING_APPROVE_VALUE';
